export const environment = {
  env: 'teste',
  url: 'https://teste.hubmedical.com.br/',
  apiUrl: 'https://hubmedical-app-teste.fly.dev/',
  production: false,
};

